/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/Connection/Content/SetupAutomations/Content/Content/Title"
  
}) {
let connectionDefinitionTitleValueData = fromData.useDataValue({ viewPath,
context: 'connection_definition',
path: 'title',
})
let stepsStepsValueData = fromData.useDataValue({ viewPath,
context: 'steps',
path: 'steps',
})
let aggregateData = fromHelpers.getText(connectionDefinitionTitleValueData, stepsStepsValueData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 weight="medium"
 color={dtColorsNeutral900}
 data="connection_definition.title"
 data="steps.steps"
 aggregate="helpers.js getText"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}